import {ErrorCode} from "~/enums/errorHandling/errorCode";
import {Hash} from "~/interfaces/hashInterfaces";
import Model from "~/models/model";
import ErrorHandler from "~/models/errorHandling/errorHandler";
import {TErrorCollection} from "~/interfaces/errorInterfaces";
import store from "~/state/store";

export default function (initialErrors: TErrorCollection = {}) {
  return {
    namespaced: true,
    state: {
      errors: <TErrorCollection>initialErrors,
    },
    mutations: {
      set(state, {errors}: {errors: TErrorCollection}) {
        state.errors = errors;
      },
      reset(state) {
        state.errors = {};
      },
    },
    actions: {
      handle({state, commit}, {data, model, options}: {data: Hash & {code: ErrorCode}, model: Model, options: Hash & {flash?: boolean}}) {
        if (data.code) {
          const errorHandler = new ErrorHandler(data, model)
          errorHandler.updateModel()
          if (options.flash) {
            commit('flashStore/set', {flash: {alert: errorHandler.message}}, {root: true})
          }
        } else if (data.errors) {
          let otherErrors = Object.keys(data.errors).filter(e => e !== "client_idable_errors");
          if (otherErrors.length > 0) {
            store.commit('flashStore/set', {
              flash: {
                alert: Object.values(otherErrors).join(", ")
              }
            });
          }
        }
      },
    }
  };
}